import * as Yup from 'yup';
import { CommonMessages } from 'src/messages/validationMessages';
import { getPhoneRegex, getActiveCountryCode } from 'src/utils/countryHelper';

export const phoneField = (countryCode?: string) =>
  Yup.string()
    .matches(getPhoneRegex(countryCode || getActiveCountryCode()), CommonMessages.phone_invalid)
    .required(CommonMessages.phone_required);
